import React, { useState } from "react";
import arrow from "../../../images/arrow.svg";
import { motion } from "framer-motion";

const faqsVariants = {
  open: {
    height: "auto",
  },
  close: {
    height: 0,
    margin: 0,
  },
};

const AccordionContent = ({ title, content, id }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div
      key={id}
      className={`accordion-item ${isActive && "active"}`}
      onClick={() => setIsActive(!isActive)}
    >
      <div className="accordion-title">
        <p>{title}</p>
        <div>
          <img src={arrow} className={`arrowDown ${isActive && "arrowUp"}`} />{" "}
        </div>
      </div>
      <motion.div
        className="accordion-content"
        variants={faqsVariants}
        animate={isActive ? "open" : "close"}
      >
        <div className="divider"></div>
        <p dangerouslySetInnerHTML={{ __html: content }}></p>
      </motion.div>
    </div>
  );
};

export default AccordionContent;
